import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-split-evenly",
  templateUrl: "./split-evenly.html",
  styleUrls: ["./split-evenly.scss"],
  standalone: false
})
export class SplitEvenlyComponent {
  @Input() totalPeople = 1;
  @Input() payingFor = 0;
  @Input() maxPayers: number | null = null;
  @Input() currentPayers: number | null = null;
  @Input() billAmount = 0;
  @Input() totalRemaining = 0;

  @Output() incTotalPeople = new EventEmitter<void>();
  @Output() decTotalPeople = new EventEmitter<void>();
  @Output() incPayingFor = new EventEmitter<void>();
  @Output() decPayingFor = new EventEmitter<void>();

  get isIncTotalPeopleDisabled(): boolean {
    const max = this.maxPayers;
    return max !== null && !Number.isNaN(max) && this.totalPeople >= max;
  }

  get isDecTotalPeopleDisabled(): boolean {
    return this.totalPeople <= 1;
  }

  get isIncPayingForDisabled(): boolean {
    const remaining = this.remainingPayers;
    if (remaining !== null && this.payingFor >= remaining) return true;
    return this.payingFor >= this.totalPeople;
  }

  get isDecPayingForDisabled(): boolean {
    return this.payingFor <= 0;
  }

  private get remainingPayers(): number | null {
    const max = this.maxPayers;
    const current = this.currentPayers;
    if (max === null || current === null) return null;
    return Math.max(0, max - current);
  }
}
